/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from 'axios'
import router from '../router'
import { baseApiUrl, renewLocalStorage, avatarPhoto } from "../global";
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  async updateUserInfo({ commit }, user) {
    axios.defaults.headers.common['Authorization'] = `bearer ${user.token}`
    commit('SET_USER_INFO', user)
    renewLocalStorage(user.token)
  },

  async createUserInfo({ commit }, user) {
    commit('SET_USER_INFO', user)
  },

  async updateAvatar({ commit }, idUser) {

    let data = {
      idUser: idUser
    }
    let response = await axios.post(`${baseApiUrl}/avatar/getAvatar`, data)
    localStorage.setItem(avatarPhoto, response.data)
    commit('SET_AVATAR', response.data)
  },


  async updateUsers({ commit }) {
    const response = await axios.get(`${baseApiUrl}/user/getActiveUsers`);
    commit('SET_USERS_INFO', response.data)
  },


  async fetchAllUsers({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/user/getActiveUsers`);
      payload.loading.close()
      commit('SET_USERS_FILTERED', response.data)
    } catch (error) {
      console.log(error)
    }
  },

  // ----- Products -------//

  async setCurrentOrderProduct({ commit }, payload) {

    commit('SET_CURRENT_PRODUCT_ORDER', payload)


  },

  async addCurrentOrderProduct({ commit }, payload) {

    commit('ADD_NEW_PRODUCT', payload)

  },
  async fetchProductsItems({ commit }, payload) {
    let data = {}
    //console.log(payload)
    if ( payload.typeOrder && payload.idCustomer) {
      data = {
        idOrder: payload.idOrder,
        typeOrder: payload.typeOrder,
        idCustomer: payload.idCustomer
      }
    }else{
      data = {
        idOrder: null,
        typeOrder: null,
        idCustomer: null
      }
    }
    try {
      payload.loading()
      const response = await axios.post(
        `${baseApiUrl}/product/getAllProducts`, data);
      commit('SET_PRODUCTS', response.data)
    } catch (error) {
      console.log(error)
    } finally{
      payload.loading.close()
    }

  },

  async addNewProduct({ commit }, payload) {

    try {
      let res = await axios.post(`${baseApiUrl}/product/save`, payload.product)
      payload.product.idProduct = res.data[0]
      payload.product.photoProduct = res.data[1]
      commit('ADD_NEW_PRODUCT', payload.product)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async updateProduct({ commit }, payload) {
    try {
      let res = await axios.post(`${baseApiUrl}/product/update`, payload.product)
      payload.product.photoProduct = res.data
      commit('UPDATE_PRODUCT', payload.product)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })

    }
  },


  async addNewProductOLD({ commit }, payload) {

    try {
      let res = await axios.post(`${baseApiUrl}/product/save`, payload.formData, {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        }
      })
      console.log(res)
      payload.product.idProduct = res.data[0]
      payload.product.photoProduct = res.data[1]
      commit('ADD_NEW_PRODUCT', payload.product)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async updateProductOLD({ commit }, payload) {
    try {
      let res = await axios.post(`${baseApiUrl}/product/update`, payload.formData, {
        headers: {
          'accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        }
      })
      payload.product.photoProduct = res.data
      commit('UPDATE_PRODUCT', payload.product)
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })

    }
  },

  async removeProduct({ commit }, payload) {
    let idProduct = payload.idProduct
    let photoProduct = payload.photoProduct
    try {
      await axios.post(`${baseApiUrl}/product/remove`, { idProduct, photoProduct })
      commit('REMOVE_PRODUCT', payload.idProduct)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })


    } catch (error) {
      if (error.response.status == '404') {
        payload.notify({
          title: "Erro",
          text: "Produto está sendo usado em algum pedido. " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "primary"
        })
      } else {
        payload.notify({
          title: "Erro",
          text: "Não foi possivel apagar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        })
      }
    }
  },

  async fetchTotalProducts({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/product/getTotalProducts`
      )
      payload.loading.close()
      commit('SET_TOTAL_PRODUCTS', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },








}

export default actions
